document.addEventListener('DOMContentLoaded' , CCPASignUpFormInit );

function CCPASignUpFormInit() {
    openForm();
}

function openForm() {
    const options = document.querySelector('#state-of-residency');
    if ( options != null ) {
      options.addEventListener( 'change', handleCCPADropdownEvent );
    }
}

function handleCCPADropdownEvent( e ) {
    const target = e.target;
    const ccpaForm = document.querySelector('#ccpa-request-form');
    const notice = document.querySelector('#ccpa-request-notice');

    if ( target.value == "CA" ) {
        if ( ccpaForm != null ) {
            ccpaForm.classList.remove('hidden');
        }

        if ( notice != null ) {
            notice.classList.add('hidden');
        }
    } else {
        if ( ccpaForm != null ) {
            ccpaForm.classList.add('hidden');
        }

        if ( notice != null ) {
            notice.classList.remove('hidden');
        }
    }

    return;
}